<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import Switch from 'dashboard/components-next/switch/Switch.vue';
import Input from 'dashboard/components-next/input/Input.vue';

const { t } = useI18n();

// Same "no migration" trick as theme.layout: welcome config rides inside the
// theme JSONB (theme.welcome), so the whole editor works against the shared
// theme v-model instead of its own dedicated prop/column.
const theme = defineModel({ type: Object, required: true });

const welcome = computed(() => theme.value.welcome || {});

const updateWelcome = (key, value) => {
  theme.value = {
    ...theme.value,
    welcome: { ...welcome.value, [key]: value },
  };
};
</script>

<template>
  <div class="flex flex-col gap-4">
    <div class="flex flex-col gap-1">
      <h3 class="text-base font-semibold text-n-slate-12">
        {{ t('FORMS_MGMT.EDITOR.WELCOME.TITLE') }}
      </h3>
      <p class="text-sm text-n-slate-11">
        {{ t('FORMS_MGMT.EDITOR.WELCOME.DESCRIPTION') }}
      </p>
    </div>

    <label class="flex items-center gap-2">
      <Switch
        :model-value="!!welcome.enabled"
        @update:model-value="value => updateWelcome('enabled', value)"
      />
      <span class="text-sm font-medium text-n-slate-12">
        {{ t('FORMS_MGMT.EDITOR.WELCOME.ENABLED') }}
      </span>
    </label>

    <template v-if="welcome.enabled">
      <Input
        :model-value="welcome.title"
        :label="t('FORMS_MGMT.EDITOR.WELCOME.HEADLINE_LABEL')"
        :placeholder="t('FORMS_MGMT.EDITOR.WELCOME.HEADLINE_PLACEHOLDER')"
        @update:model-value="value => updateWelcome('title', value)"
      />

      <label class="flex flex-col gap-1">
        <span class="text-sm font-medium text-n-slate-12">
          {{ t('FORMS_MGMT.EDITOR.WELCOME.DESCRIPTION_LABEL') }}
        </span>
        <textarea
          :value="welcome.description"
          rows="3"
          class="form-textarea"
          :placeholder="t('FORMS_MGMT.EDITOR.WELCOME.DESCRIPTION_PLACEHOLDER')"
          @input="event => updateWelcome('description', event.target.value)"
        />
      </label>

      <Input
        :model-value="welcome.button_text"
        :label="t('FORMS_MGMT.EDITOR.WELCOME.BUTTON_LABEL')"
        :placeholder="t('FORMS_MGMT.EDITOR.WELCOME.BUTTON_PLACEHOLDER')"
        @update:model-value="value => updateWelcome('button_text', value)"
      />
    </template>
  </div>
</template>
